import { render, staticRenderFns } from "./fagron.vue?vue&type=template&id=c4e826c0&"
import script from "./fagron.vue?vue&type=script&lang=js&"
export * from "./fagron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseVideo: require('/app/components/case/video.vue').default,CaseContent: require('/app/components/case/content.vue').default,CaseCta: require('/app/components/case/cta.vue').default})
